/* import __COLOCATED_TEMPLATE__ from './address-confirmation.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();